
<div class="flex-row-container m-b5 m-t10" > 
    <span class="B flex-1 font20"></span>
    <button mat-stroked-button class="" [ngClass]="isDataChanged?'highlight-bg':''" color="primary" (click)="saveSelectedClients()">Save</button>            
</div>
    <!-- Primary, Secondary Clients and Add Person-->
<div class="flex-col-center">
    <div class="flex-row-container-wrap">
        <div *ngFor="let cl of planClients">        
            <div *ngIf="cl.role==='Primary' || cl.role==='Secondary'" class="flex-col-center m-r50 m-b15">
                <button mat-fab class="client-initials" style="background-color: var(--neutralPrimary)"
                    [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: cl.clientid}">        
                    <div class="flex-col-center m-t10">
                        <span>{{cl.initials}}</span>
                        <span class="font16">{{cl.age?cl.age:'-'}}</span>
                    </div>
                </button>
                <span class="m-5 font16">{{cl.clientname}}</span>                
                <span *ngIf="cl.legalEntityType" class="blueText14" style="margin-top: -8px">({{cl.legalEntityType}})</span>                
            </div>
        </div>
        <div *ngIf="showAddPerson" class="flex-col-center m-t20">
            <button mat-fab class="pointer client-initials_add" (click)="loadClientMenu();" [matMenuTriggerFor]="addclientMenu">
                <mat-icon class="font25" style="color: var(--white) !important">add</mat-icon>
            </button>
            <span class="B m-5">Add Person or Entity</span>        
        </div>               
    </div>
    <div *ngIf="showSearch" class="flex-col-center m-15 searchPanel">
        <gp-client-search (SearchSelection)="onSearchSelection($event)"></gp-client-search>
    </div>  
    <!-- Other Clients-->
    <div class="flex-row-container-wrap">
        <div *ngFor="let cl of planClients">        
            <div *ngIf="cl.role!=='Primary' && cl.role!=='Secondary'" class="flex-col-center m-r50 m-tb15">
                <button mat-fab class="client-initials" style="background-color: var(--themePrimaryContrast)"
                    [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: cl.clientid}">        
                    <div class="flex-col-center m-t10">
                        <span>{{cl.initials}}</span>
                        <span class="font16">{{cl.age?cl.age:'-'}}</span>   
                    </div>
                </button>
                <span class="m-5 font16">{{cl.clientname}}</span>  
                <span *ngIf="cl.legalEntityType" class="blueText14" style="margin-top: -8px">({{cl.legalEntityType}})</span>                  
            </div>
        </div>      
    </div>    
</div>

<!-- Client Summary -->
<mat-menu #clientMenu="matMenu" >
    <ng-template matMenuContent let-clientid="clientid">
        <gp-client-summary [ClientId]="clientid"></gp-client-summary>
    </ng-template>
</mat-menu>

<!-- Spouse and Othe Clients -->
 <mat-menu #addclientMenu="matMenu">  
    <div class="" *ngFor="let item of clientsMenuItems">
        <button class="font14" mat-menu-item [matMenuTriggerFor]="sub_menu"> {{item.displayClientTypeName}}</button>      
        <mat-menu #sub_menu="matMenu">
            <button *ngFor="let subItem of item.subMenuItems"  class="font14" mat-menu-item (click)="addClient(subItem.role, subItem.clientid, subItem.clientname)" >
                <span *ngIf="!subItem.clientid" class="blueText16 B">{{ subItem.clientname }}<mat-icon class="B m-l10 m-t5 blueText18" *ngIf="!subItem.clientid">search</mat-icon></span>
                <span *ngIf="subItem.clientid">
                    <span>{{ subItem.clientname }}</span>
                    <span *ngIf="subItem.legalEntityType" class="m-l5 blueText14">({{ subItem.legalEntityType }})</span>                    
                </span>
            </button>
        </mat-menu>
    </div>   
</mat-menu>
